import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ExitFullScreenIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M14 19V14H19V16H16V19H14ZM8 8V5H10V10H5V8H8Z' fill='currentColor' />
        </>
    ),
})

ExitFullScreenIcon.displayName = 'ExitFullScreenIcon'
